import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { InputRange } from '../../ui-kit/InputRange/InputRange.js';
import { Text } from '../../ui-kit/Text/Text.js';
const ITEMS = ['От 1 дня', 'До 365 дней'];
const MIN = 1;
const MAX = 365;
export const RentalPeriod = JSX(({ days, setDays }) => (_jsxs("div", { className: "order-1", children: [_jsx(Text, { size: "text-m", font: "font-light", children: "\u0421\u0440\u043E\u043A \u0430\u0440\u0435\u043D\u0434\u044B" }), _jsx(InputRange, { min: MIN, max: MAX, value: days, items: ITEMS, onChange: setDays })] })));
//# sourceMappingURL=RentalPeriod.js.map